import { datadogRum } from "@datadog/browser-rum";
import { APP_ENV, ENV_NAMES, tracingUrl } from "@utils/env";
import { watchPopupPositions } from "@utils/popupPositionWatch";
import { reportScrollGlobalWrites } from "@utils/scrollGlobalGuard";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import "./polyfills";

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: "us3.datadoghq.com",
  service: "frontera-portal-ui",
  env: APP_ENV,
  version: import.meta.env.VITE_COMMIT_HASH || "<missing-version>",
  sessionSampleRate: 100,
  sessionReplaySampleRate: APP_ENV === ENV_NAMES.PROD ? 100 : 0,
  allowedTracingUrls: tracingUrl ? [tracingUrl] : undefined,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
});
// PROA-2811/PROA-3108 diagnostics, temporary; PROA-3108's follow-ups set when each comes out. The guard
// (index.html <script>, public/scroll-global-guard.js, scrollGlobalGuard.ts) has its own exit; the
// watcher goes with the root-cause fix.
reportScrollGlobalWrites();
watchPopupPositions();

hydrateRoot(
  document,
  <StrictMode>
    <HydratedRouter />
  </StrictMode>,
);
